import { Checkbox, type CheckboxChangeEvent, Form } from "antd"

import { ReactChild } from "#customTypes/globalTypes"

import DisabledFieldTooltip from "./DisabledFieldTooltip"

const MARGINS_BY_SIZE = {
  large: 16,
  medium: 12,
  small: 0,
}

const SCALE_BY_SIZE = {
  large: 1.1,
  medium: 1,
  small: 0.9,
}

// Created this to avoid mistakes around valuePropName="checked"
const CheckboxWrapper = ({
  name,
  label,
  onChange,
  size = "large",
  value,
  disabledTooltip,
}: {
  name?: string | string[] // Don't pass name if you want to use the value prop. Antd Form takes over.
  label: string | ReactChild
  onChange?: (e: CheckboxChangeEvent) => void
  value?: boolean
  size?: "large" | "medium" | "small"
  disabledTooltip?: string
}) => {
  const disabled = !!disabledTooltip

  return (
    <DisabledFieldTooltip disabled={disabled} tooltip={disabledTooltip}>
      <Form.Item
        name={name}
        valuePropName="checked"
        style={{ marginBottom: MARGINS_BY_SIZE[size] }}
      >
        <Checkbox
          style={{
            // It looks better just a bit bigger
            transform: `scale(${SCALE_BY_SIZE[size]})`,
            transformOrigin: "top left",
            userSelect: "none",
          }}
          checked={value}
          onChange={onChange}
          disabled={disabled}
        >
          {label}
        </Checkbox>
      </Form.Item>
    </DisabledFieldTooltip>
  )
}

export default CheckboxWrapper
